module.exports = __webpack_public_path__ + "static/media/paleta.5772d5cc.jpeg";